import React, { useState } from 'react'
import StarIcon from '../../../assets/images/front/svg/star.svg'
import Modal from 'react-modal'

type ReviewProps = {
  name: string
  stars: number
  text: string
}

const Review: React.FC<ReviewProps> = ({ name, stars, text }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const truncatedText = text.length > 100 ? text.slice(0, 100) + '…' : text

  return (
    <>
      <div className="px-1 ">
        <div
          className="relative flex flex-col p-5 rounded-3xl bg-white h-[240px] cursor-pointer"
          onClick={() => setModalIsOpen(true)}
        >
          <h4 className="font-semibold text-[#0183BA] font-myriad">{name}</h4>
          <div className="flex items-center gap-1 mb-8">
            {[...Array(stars)].map((_, i) => (
              <img key={i} src={StarIcon} alt="star" className="w-5 h-5" />
            ))}
          </div>
          <p>{truncatedText}</p>
          <span className="absolute -top-10 right-4 z-100 text-[122px] leading-none text-[#A8CD00] font-medium font-myriad">
            “
          </span>
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        className="fixed inset-0 flex items-center justify-center outline-none pointer-events-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-40 z-50"
        ariaHideApp={false}
      >
        <div className="bg-white rounded-3xl p-8 max-w-lg w-full relative">
          <button
            className="absolute top-2 right-3 text-gray-500 hover:text-black text-2xl"
            onClick={() => setModalIsOpen(false)}
            aria-label="Close"
          >
            &times;
          </button>
          <h4 className="font-semibold text-[#0183BA] font-myriad mb-2">{name}</h4>
          <div className="flex items-center gap-1 mb-4">
            {[...Array(stars)].map((_, i) => (
              <img key={i} src={StarIcon} alt="star" className="w-5 h-5" />
            ))}
          </div>
          <p>{text}</p>
        </div>
      </Modal>
    </>
  )
}

export default Review
